import deburr from 'lodash/deburr';

import type { TNode } from '../Node';
import { getRawIdFromNestedId } from './idParsing';
import { resolveSuggestedTitles } from './normalizeSuggestedTitles';

export const searchMatch = (node: TNode, search: string) => {
  const trimmedSearch = search.trim();
  const isNumericSearch = /^\d+$/.test(trimmedSearch);
  if (isNumericSearch) {
    return (
      node.data.id != null &&
      getRawIdFromNestedId(String(node.data.id)) === trimmedSearch
    );
  }

  return isDirectMatch(node, search) || isSuggestedMatch(node, search);
};

/** ================= Direct Match ================= */
export const isDirectMatchString = (value: string, search: string) =>
  deburr(value.toLowerCase().trim()).includes(
    deburr(search.toLowerCase().trim())
  );
export const isDirectMatch = (node: TNode, search: string) =>
  isDirectMatchString(node.data.name, search);

/** ================= Suggested Match ================= */
const isSuggestedMatchString = (values: string[], search: string) =>
  values.some((value) =>
    deburr(value.toLowerCase().trim()).includes(
      deburr(search.toLowerCase().trim())
    )
  );
export const isSuggestedMatch = (node: TNode, search: string) => {
  const suggestedTitles = resolveSuggestedTitles(node.data);
  if (!suggestedTitles) return false;
  return isSuggestedMatchString(suggestedTitles, search);
};
